module.exports = __webpack_public_path__ + "static/media/thumb.9e677a83.png";